import { HttpClient } from './http-client';
import { 
  ApiKey,
  ApiKeyWithPlainText,
  ApiKeyListResponse,
  CreateApiKeyRequest
} from '../types';

export class ApiKeyService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get all API keys for a division
   */
  async getDivisionApiKeys(divisionId: string): Promise<ApiKeyListResponse> {
    return this.httpClient.get<ApiKeyListResponse>(`/api/v1/divisions/${divisionId}/api-keys`);
  }

  /**
   * Create a new API key for a division
   * Returns the API key with the plain text key (only shown once)
   */
  async createApiKey(divisionId: string, request: CreateApiKeyRequest): Promise<ApiKeyWithPlainText> {
    return this.httpClient.post<ApiKeyWithPlainText>(`/api/v1/divisions/${divisionId}/api-keys`, request);
  }

  /**
   * Delete an API key
   */
  async deleteApiKey(divisionId: string, apiKeyId: string): Promise<void> {
    return this.httpClient.delete<void>(`/api/v1/divisions/${divisionId}/api-keys/${apiKeyId}`);
  }
}
